import React, {useRef, useState} from "react"
import {findDOMNode} from "react-dom"

import NavigationMenuAddPopover from "./popover"
import Menu_IconAdd from "../../components/molecules/icon-add";

type Props = {
    className?  : string

    label       : string
    projectId?  : ID

    onAddInline : func
}

export default function NavigationMenuAddWithPopover(props:Props) {
    const selfRef: any = useRef()
    const [popoverShown, setPopoverShown] = useState(false)

    const showPopover = (e: any) => {
        e.stopPropagation();
        if (!popoverShown) setPopoverShown(true)
    }

    const hidePopover = () => {
        if (popoverShown) setPopoverShown(false)
    }

    return (
        <div ref={selfRef} className={Classes('item', props.className)} onClick={showPopover}>
            <div className="row">
                <div className="flex-row-between-center w-100-percent">
                    <div className="flex-row-left-center">
                        <Menu_IconAdd />
                        <div className="name">{props.label}</div>
                    </div>

                    <div className="item-popover-arrow ui5-ico-12 i5-angle-right"/>
                </div>
            </div>

            {popoverShown &&
                <NavigationMenuAddPopover projectId             = {props.projectId}
                                          getTargetFunc         = {()=>findDOMNode(selfRef.current)}
                                          hidePopover           = {hidePopover}
                                          showAdditionalViews   = {true}
                                          onAddInline           = {props.onAddInline}/>}
        </div>
    )
}
